var React = require('react');

function ArrowHorizontal (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"#fff","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2"},[React.createElement("path",{"d":"m1 8h14","key":0}),React.createElement("path",{"d":"m8 1 7 7-7 7","key":1})]));
}

ArrowHorizontal.defaultProps = {"fill":"none","height":"16","viewBox":"0 0 16 16","width":"16"};

module.exports = ArrowHorizontal;

ArrowHorizontal.default = ArrowHorizontal;
